import Wujie from '@/components/wujie'

export default {
  routes: [

    // 驾驶舱
    {
      path: 'cockpit',
      name: 'cockpit',
      component: Wujie,
      props: { type: 'cockpit' },
      children: [
        {
          path: 'AgingStatistics',
          meta: { title: "账龄分析" },
        },
        {
          path: 'PaymentStatistics',
          meta: { title: "缴费总览" } },
        {
          // path: 'EnergyConsumptionStatistics',
          path: 'chartStatistics',
          meta: { title: "能耗管理" },
        },
        {
          path: 'pda',
          meta: { title: "到家巡检" } },
        {
          path: 'conversation',
          meta: { title: "舆情管理" },
        },
        {
          path: 'ReportRepairStatistics',
          meta: { title: "物业端" },
        },
        {
          path: 'ReportRepairOwnerStatistics',
          meta: { title: "业主端" },
        },
        {
          path: 'Group400Statistics',
          meta: { title: "品控中心" },
        },
        {
          path: 'ComplaintSuggestionsStatistics',
          meta: { title: "投诉建议" },
        },
        {
          path: 'VisitStatistics',
          meta: { title: "业主拜访" }
        },
        {
          path: 'SatisfactionStatistics',
          meta: { title: "满意度调查" }
        },
        {
          path: 'historyRate',
          meta: { title: "历年收缴" }
        },
        {
          // path: 'EnergyConsumptionStatistics',
          path: 'chart',
          meta: { title: "能耗管理" },
        },
        {
          path: 'badDebtSetting',
          meta: { title: "坏账拨备设置" }
        },
        {
          path: 'badDebt',
          meta: { title: "坏账拨备" }
        },
        {
          path: 'actualDebt',
          meta: { title: "实际拨备" }
        },
        {
          path: 'historyCollection',
          meta: { title: "收缴通报" }
        },
        {
          path: 'planRate',
          meta: { title: "龙虎榜" }
        },
        {
          path: 'parking',
          meta: { title: "智慧停车" }
        },
      ]
    },

    // 协同办公
    {
      path: '/',
      name: 'CollaborativeOffice',
      component: Wujie,
      props: { type: 'office' },
      children: [
        {
          path: 'mail',
          children: [
            { path: 'list', meta: { title: "收件箱" } },
            { path: 'write', meta: { title: "写信" } },
            { path: 'draft', meta: { title: "草稿箱" } },
            { path: 'sent', meta: { title: "已发送" } },
            { path: 'trash', meta: { title: "已删除" } },
            { path: 'detail', meta: { title: "邮件详情" } },
          ],
        },
        {
          path: 'new',
          children: [
            {path: 'newList', meta: { title: "新闻列表" }},
            {path: 'detail', meta: { title: "新闻详情" }},
            {path: 'create', meta: { title: "新建新闻" }},
            {path: 'newManageList', meta: { title: "新闻管理" }},
          ],
        },
        {
          path: 'notice',
          children: [
            {path: 'receiveList', meta: { title: "我的收文" }},
            {path: 'create', meta: { title: "创建公文" }},
            {path: 'detail', meta: { title: "收文详情" }},
          ],
        },
        {
          path: 'notice',
          children: [
            {path: 'sendList', meta: { title: "我的发文" }},
            {path: 'detail', meta: { title: "发文详情" }},
          ],
        },
      ],
      meta: {
        title: "协同办公"
      }
    },

    // PDA
    {
      path: 'pda',
      name: 'pda',
      component: Wujie,
      props: { type: 'pda' },
      children: [
        { path: 'home', meta: { title: "巡检概况" } },
        { path: 'bluetooth', meta: { title: "蓝牙管理" } },
        { path: 'equipment', meta: { title: "任务管理" } },
        { path: 'check', meta: { title: "任务抽检" } },
        { path: 'inspection', meta: { title: "巡检管理" } },
        { path: 'diary', meta: { title: "操作日记" } },
        { path: 'jurisdiction', meta: { title: "权限架构" } },
        { path: 'department', meta: { title: "部门管理" } },
        { path: 'user', meta: { title: "人员管理" } },
        { path: 'repair', meta: { title: "整改工单" } },
        { path: 'map', meta: { title: "地图巡航" } },
        { path: 'deviceIndex', meta: { title: "工牌设备" } },
        { path: 'deviceUserIndex', meta: { title: "工牌管理" } },
      ],
    },

    // PDA NEW
    {
      path: 'quality-pda',
      component: Wujie,
      props: { type: 'quality' },
      children: [
        { path: 'third-overview', meta: { title: "非主营概况" } },
        { path: 'account', meta: { title: "帐号管理" } },
        { path: 'department', meta: { title: "权限架构" } },
        { path: 'user', meta: { title: "人员管理" } },
        { path: 'address', meta: { title: "地点管理" } },
      ]
    },

    // 智慧校园
    {
      path: 'school',
      component: Wujie,
      props: { type: 'school' },
      children: [
        { path: 'goodslist', meta: { title: "学生缴费" } },
        { path: 'getStatement', meta: { title: "月统计" } },
        { path: 'chartStatistics', meta: { title: "缴费统计" } },
      ]
    },

    //能耗管理
    {
      path: 'secp',
      component: Wujie,
      props: { type: 'secp' },
      children: [
        // { path: 'memberHouse', meta: { title: "住户管理" } },
        // { path: 'energyRegion', meta: { title: "用能分区" } },
        { path: 'settlementPlan', meta: { title: "结算方案" } },
        { path: 'meterNoteDetail', meta: { title: "用能抄表" } },
        { path: 'order', meta: { title: "账单查询" } },
        { path: 'type', meta: { title: "资产管理" } },
        { path: 'useType', meta: { title: "用能类型管理" } },
        { path: 'use', meta: { title: "用能用途" } },
        { path: 'chartStatistics', meta: { title: "能耗管理" } },
        { path: 'useWarn', meta: { title: "用能预警" } },
        { path: 'chartUseWarn', meta: { title: "预警分析" } },
      ]
    },
    // 耗能管理页面
    {
      path: 'stat',
      component: Wujie,
      props: { type: 'secp' },
      children: [
        { path: 'chart', meta: { title: "能耗管理" } },
        { path: 'publicShareMeter', meta: { title: "公摊能耗分析" } },
        { path: 'meterInformation', meta: { title: "数据完整分析" } },
      ]
    },
    // 品质管理 - AI监控
    {
      path: 'camera',
      component: Wujie,
      props: { type: 'quality' },
      children: [
        { path: 'device', meta: { title: "设备管理" } },
      ]
    },

    // 满意度明细
    {
      path: 'question',
      component: Wujie,
      props: { type: 'quality' },
      children: [
        { path: 'question_answer', meta: { title: "满意度明细" } },
        { path: 'question_house', meta: { title: "参与调查房产" } },
        { path: 'question_sms', meta: { title: "短信推送记录" } },
      ]
    },

    // 品质管理 - 企业微信管理
    {
      path: 'wework',
      component: Wujie,
      props: { type: 'quality' },
      children: [
        { path: 'member', meta: { title: "员工管理" } },
        { path: 'group', meta: { title: "客户群管理" } },
      ]
    },

    // 业主拜访
    {
      path: 'visit',
      component: Wujie,
      props: { type: 'quality' },
      children: [
        { path: 'log', meta: { title: "业主拜访" } },
      ]
    },

    // 品质检查
    {
      path: 'quality-check',
      component: Wujie,
      props: { type: 'quality' },
      children: [
        { path: 'category', meta: { title: "检查分类" } },
        { path: 'template', meta: { title: "检查模板" } },
        { path: 'schedule', meta: { title: "年度计划" } },
        { path: 'record', meta: { title: "检查记录" } },
        { path: 'record-list', meta: { title: "检查记录" } },
        { path: 'repair', meta: { title: "整改记录" } },
        { path: 'report', meta: { title: "检查报告 " } },
        { path: 'reports', meta: { title: "检查报表" } },
      ]
    },

    // 客户分类
    {
      path: 'client',
      component: Wujie,
      props: { type: 'quality' },
      children: [
        { path: 'client_type', meta: { title: "客户分类" } },
      ]
    },
    // 客户信息
    {
      path: 'client',
      component: Wujie,
      props: { type: 'quality' },
      children: [
        { path: 'client_customer', meta: { title: "客户业主信息" } },
      ]
    },
    // 客户信息
    {
      path: 'client',
      component: Wujie,
      props: { type: 'quality' },
      children: [
        { path: 'client_list', meta: { title: "客户信息" } },
      ]
    },
    // 计划拜访
    {
      path: 'client',
      component: Wujie,
      props: { type: 'quality' },
      children: [
        { path: 'visit_plan', meta: { title: "计划拜访" } },
        { path: 'visit_project', meta: { title: "计划方案" } },
        { path: 'visit_gags', meta: { title: "计划花絮" } },
        { path: 'visit_report', meta: { title: "计划总结" } },
      ]
    },

    // 人力资源 - 排班
    {
      path: 'workclass',
      component: Wujie,
      props: { type: 'hr' },
      children: [
        { path: 'class', meta: { title: "班次设置" } },
        { path: 'class-edit', meta: { title: "编辑班次" } },
        { path: 'user', meta: { title: "排班管理" } },
        { path: 'check', meta: { title: "排班审核" } },
        { path: 'schedule', meta: { title: "排班计划表" } },
      ]
    },

    // 人力资源 - 薪酬管理
    {
      path: 'hr-salary',
      component: Wujie,
      props: { type: 'hr' },
      children: [
        { path: 'basic-setting', meta: { title: "基数设置" } },
        { path: 'salary-well-user-import', meta: { title: "基数设置导入" } },
        { path: 'salary-setting', meta: { title: "薪酬设置" } },
        { path: 'salary-setting-edit', meta: { title: "新增薪酬" } },
        { path: 'salary-account-set', meta: { title: "工资账套" } },
        { path: 'salary-staff', meta: { title: "绑定员工" } },
        { path: 'early-warning-department', meta: { title: "预警部门" } },
        { path: 'calculation-account-set', meta: { title: "算薪账套" } },
        { path: 'reporting-management', meta: { title: "填报管理" } },
        { path: 'reporting-setting', meta: { title: "填报项设置" } },
        { path: 'reporting-detail', meta: { title: "明细台账" } },
        { path: 'reporting-import', meta: { title: "添加补发代扣审批" } },
        { path: 'reporting-report', meta: { title: "审批明细台账" } },
        { path: 'salary-management-list', meta: { title: "薪酬管理" } },
        { path: 'salary-management-details', meta: { title: "发放工资表" } },
        { path: 'salary-management-report', meta: { title: "审批工资列表" } },
        { path: 'month-check', meta: { title: "月度检查" } },
        { path: 'salary-details', meta: { title: "薪酬明细" } },
        { path: 'cardinal-change', meta: { title: "异动检查" } },
        { path: 'cardinal-change-details', meta: { title: "基数异动明细表" } },
        { path: 'personnel-change-details', meta: { title: "人员异动明细表" } },
        { path: 'salary-change-details', meta: { title: "薪酬异动明细表" } },
        { path: 'subsidy-management', meta: { title: "补贴管理" } },
        { path: 'salary', meta: { title: "薪资发放" } },
        { path: "reporting-result", meta: {title: "添加绩效考核审批"}},
        { path: "salary-split", meta: {title: "分盘管理"}},
        { path: "salary-split-order", meta: {title: "分盘订单列表"}}
      ]
    },

    // 人力资源 - 基础设置
    {
      path: 'hr-setting',
      component: Wujie,
      props: { type: 'hr' },
      children: [
        { path: 'post-setting', meta: { title: "岗位设置" } },
        { path: 'group', meta: { title: "族群管理" } },
        { path: 'post-manage', meta: { title: "岗位管理" } },
        { path: 'position', meta: { title: "职位管理" } },
        { path: 'social-insurance', meta: { title: "社保管理" } },
        { path: 'fund-manage', meta: { title: "公积金管理" } },
        { path: 'pay-relation-manage', meta: { title: "缴纳关系管理" } },
        { path: 'legal_unit', meta: { title: "法定单位" } },
        { path: 'company', meta: { title: "劳务公司" } },
        { path: 'rank-setting', meta: { title: "职级设置" } },
        { path: 'bank-setting', meta: { title: "银行管理" } },
      ]
    },

    // 人力资源 - 考勤管理
    {
      path: 'workcheck',
      component: Wujie,
      props: { type: 'hr' },
      children: [
        { path: 'app-list', meta: { title: "考勤机管理" } },
        { path: 'installation-method', meta: { title: "考勤机管理-员工策略" } },
        { path: 'installation-user', meta: { title: "考勤机管理-员工列表" } },
        { path: 'sync-center', meta: { title: "考勤机管理-同步中心" } },
        { path: 'set-list', meta: { title: "考勤设置" } },
        { path: 'department', meta: { title: "考勤部门" } },
        { path: 'work_check_record', meta: { title: "考勤记录" } },
        { path: 'work_check_maintenance', meta: { title: "考勤维护" } },
        { path: 'work_check_examine', meta: { title: "考勤审核" } },
        { path: 'work_check_annual', meta: { title: "年休假" } },
        { path: 'work_check_year', meta: { title: "调休假" } },
        { path: 'eWorkCheck', meta: { title: "考勤点设置" } },
        { path: 'eUserList', meta: { title: "员工列表" } },
        { path: 'eWorkCheckRecord', meta: { title: "考勤记录" } },
      ]
    },
    {
      path: 'attendance',
      component: Wujie,
      props: { type: 'hr' },
      children: [
        { path: 'machine', meta: { title: "新考勤机管理" } },
      ]
    },
    // 400投诉
    {
      path: 'complaint400',
      component: Wujie,
      props: { type: 'quality' },
      children: [
        { path: 'add', meta: { title: "话务处理" } },
      ]
    },
    // 400投诉历史列表
    {
      path: 'complaint400',
      component: Wujie,
      props: { type: 'quality' },
      children: [
        { path: 'list', meta: { title: "历史记录" } },
      ]
    },

    //员工信息
    {
      path: 'hr-staff',
      component: Wujie,
      props: { type: 'hr' },
      children: [
        { path: 'index', meta: { title: "员工信息" } },
        { path: 'userAdd', meta: { title: "新建员工" }},
        { path: 'UserBasicEditor', meta: { title: "基本信息" }},
        { path: 'UserPersonalEditor', meta: { title: "个人信息" }},
        { path: 'UserSalaryEditor', meta: { title: "薪资信息" }},
        { path: 'UserEducationalEditor', meta: { title: "教育经历" }},
        { path: 'UserWorkEditor', meta: { title: "工作经历" }},
        { path: 'UserTrainingEditor', meta: { title: "培训经历" }},
        { path: 'UserQualificationEditor', meta: { title: "资格证书" }},
        { path: 'UserFamilyEditor', meta: { title: "家庭信息" }},
        { path: 'UserContract', meta: { title: "员工合同" }},
        { path: 'roster', meta: { title: "花名册" } },
        { path: 'black-list', meta: { title: "黑名单管理" } },
        { path: 'level-list', meta: { title: "薪酬级别管理" } },
        { path: 'join-standards-list', meta: { title: "入职标准" } },
        { path: 'dept-hange-list', meta: { title: "员工变动明细" } },
      ]
    },
    //人事管理
    {
      path: 'hr-setup',
      component: Wujie,
      props: { type: 'hr' },
      children: [
        { path: 'company', meta: { title: "公司管理" } },
        { path: 'company-edit', meta: { title: "公司设置" } },
        { path: 'department', meta: { title: "部门管理" } },
        { path: 'department-edit', meta: { title: "部门设置" } },
        { path: 'business', meta: { title: "部门定编" } },
        { path: 'business-all', meta: { title: "批量定编人数查询" } },
        { path: 'business-edit', meta: { title: "批量定编人数设置" } },
        { path: 'business-import', meta: { title: "批量定编人数导入" } },
        { path: 'department-setting', meta: { title: "部门设置" } },
        { path: 'department-setting-detail', meta: { title: "部门编辑" } },
        { path: 'department-history', meta: { title: "历史" } },
      ]
    },
    // 奖惩管理
    {
      path: 'punishments',
      component: Wujie,
      props: { type: 'hr' },
      children: [
        { path: 'type', meta: {title: "奖惩种类设置"} },
        { path: 'list', meta: {title: "奖惩管理"} },
      ]
    },

    //预算管理
    {
      path: 'budget',
      component: Wujie,
      props: { type: 'budget' },
      children: [
        { path: 'account-list', meta: { title: "科目代码" } },
        { path: 'plan-task', meta: { title: "预算计划预览" } },
        { path: 'budget-plan', meta: { title: "预算计划" } },
        { path: 'plan-detail', meta: { title: "预算计划详情" } },
        { path: 'adjust-apply', meta: { title: "预算调整" } },
        { path: 'expense-apply', meta: { title: "费用报销" } },
        { path: 'budget-apply', meta: { title: "月度资金计划" } },
        { path: 'expense-apply-summary', meta: { title: "费用报销统计表" } },
        { path: 'budget-apply-summary', meta: { title: "费用申请汇总表" } },
      ]
    },
    //公社费
    {
      path: 'communeFees',
      component: Wujie,
      props: { type: 'budget' },
      children: [
        { path: 'account-list', meta: { title: "公设费科目" } },
        { path: 'communeFees-task', meta: { title: "公设费预览" } },
        { path: 'communeFees-plan', meta: { title: "公设费计划" } },
        { path: 'expense-apply', meta: { title: "费用报销" } },
        { path: 'budget-apply', meta: { title: "月度资金计划" } },
        { path: 'expense-apply-summary', meta: { title: "费用报销统计表" } },
        { path: 'budget-apply-summary', meta: { title: "费用申请汇总表" } },
      ]
    },

    //云发票
    {
      path: 'invoice',
      component: Wujie,
      props: { type: 'budget' },
      children: [
        { path: 'enterprise-list', meta: { title: "企业管理" } },
        { path: 'enterprise-lists', meta: { title: "企业管理" } },
        { path: 'invoice-list', meta: { title: "云发票列表" } },
        { path: 'user-list', meta: { title: "企业员工" } },
        { path: 'process-list', meta: { title: "报销中心" } },
        { path: 'bank-list', meta: { title: "银行账号" } },
        { path: 'porcess-meter-list', meta: { title: "能耗转账列表" } },
        { path: 'porcess-buy-list', meta: { title: "采购转账列表" } },
        { path: 'commune-fees-list', meta: { title: "工程项目立项" } },
        { path: 'subcontract-list', meta: { title: "工程分包支付" } },
        { path: 'set-list', meta: { title: "编码管理" } },
        { path: 'process-deposit-list', meta: { title: "押金退付管理" } },
        { path: 'salary-split', meta: { title: "薪酬分盘" } },
      ]
    },

    // 采购管理
    {
      path: 'procure',
      component: Wujie,
      props: { type: 'budget' },
      children: [
        { path: 'product-list', meta: { title: "物料管理" } },
        { path: 'storagelog-list', meta: { title: "出入库记录" } },
        { path: 'warehouse-list', meta: { title: "仓库管理" } },
        { path: 'warehouse-product-list', meta: { title: "仓库物料列表" } },
        { path: 'warehouse-bind-list', meta: { title: "仓库绑定列表" } },
        { path: 'product-category-list', meta: { title: "物料分类" } },
        { path: 'supplier-list', meta: { title: "供应商列表" } },
        { path: 'supplier-import', meta: { title: "供应商导入" } },
        { path: 'supplierProduct-import', meta: { title: "供应商商品导入" } },
        { path: 'supplier-products-list', meta: { title: "供应商-商品" } },
        { path: 'supplier-department-list', meta: { title: "供应商-项目" } },
        { path: 'supplier-products-region', meta: { title: "供应商-商品区域价格" } },
        { path: 'engineeringQuotation', meta: { title: "报价单" } },
        { path: 'engineeringQuotationAdd', meta: { title: "报价单-信息" } },
        { path: 'SaleQuotation', meta: { title: "销售价目表" } },
        { path: 'SaleQuotationAdd', meta: { title: "销售价目表-信息" } },
        { path: 'materialRequisition-list', meta: { title: "物料申购" } },
        { path: 'settlementDetail-list', meta: { title: "供应商月结算" } },
        { path: 'settlementMonth-list', meta: { title: "报销申请" } },
        { path: 'procurementQuotation', meta: { title: "采购报价单" } },
        { path: 'procurementQuotationAdd', meta: { title: "采购报价单-信息" } },
        { path: 'weakCurrentQuotation', meta: { title: "弱电报价单" } },
        { path: 'weakCurrentQuotationAdd', meta: { title: "弱电报价单-信息" } },
        { path: 'export-shipment-list', meta: { title: "发货单导出" } },
      ]
    },

    // 合同管理ERP
    {
      path: 'contract',
      component: Wujie,
      props: { type: 'budget' },
      children: [
        { path: 'cust-list', meta: { title: "客户列表" } },
        { path: 'contract-list', meta: { title: "合同列表" } },
        { path: 'cate-list', meta: { title: "分类列表" } },
        // { path: 'field-list', meta: { title: "字典列表" } },
        { path: 'template-list', meta: { title: "模板列表" } },
        { path: 'business-list', meta: { title: "业户类型列表" } },
        { path: 'finance', meta: { title: "汇总报表" } },
        { path: 'payment', meta: { title: "应收应付管理" } },
        { path: 'payment-log', meta: { title: "收付记录" } },
      ]
    },

    // 在线学习
    {
      path: 'study',
      component: Wujie,
      props: { type: 'hr' },
      children: [
        { path: 'index', meta: { title: "首页" } },
        { path: 'questionBank', meta: { title: "题库管理" } },
        { path: 'testPaper', meta: { title: "试卷管理" } },
        { path: 'required-course', meta: { title: "我的必修课" } },
        { path: 'required-course-info', meta: { title: "我的必修课-详情" } },
        { path: 'elective-courses', meta: { title: "我的选修课" } },
        { path: 'courseware-information', meta: { title: "课件信息" } },
        { path: 'requiredCourse-manage', meta: { title: "必修课管理" } },
        { path: 'requiredCourse-courseware-information', meta: { title: "必修课管理-信息" } },
        { path: 'student-manage', meta: { title: "必修课管理-学员" } },
        { path: 'learning', meta: { title: "学习" } },
        { path: 'examination', meta: { title: "考试" } },
        { path: 'correct-list', meta: { title: "试卷批改" } },
        { path: 'myExam-list', meta: { title: "我的考试" } },
        { path: 'registration-review', meta: { title: "报名审核" } },
        { path: 'Exam-list', meta: { title: "成绩查询" } },
        { path: 'exam-correct', meta: { title: "评卷" } },
        { path: 'course-category-list', meta: { title: "课程分类" } },
        { path: 'lesson-list', meta: { title: "课程管理" } },
        { path: 'student-list', meta: { title: "学员管理" } },
      ]
    },
    {
      path: 'zhoaocf',
      component: Wujie,
      props: { type: 'hr' },
      children: [
        { path: 'ledger-list', meta: { title: "价值信息" } },
        { path: 'type-list', meta: { title: "项目业态" } },
        { path: 'category-list', meta: { title: "项目分类" } },
        { path: 'region-list', meta: { title: "拓展单位" } },
        { path: 'process-list', meta: { title: "项目流程" } },
        { path: 'process-type', meta: { title: "职责类别" } }
      ]
    },
    // 培训认证
    {
      path: 'study',
      component: Wujie,
      props: { type: 'hr' },
      children: [
        { path: 'train-plan', meta: { title: "培训计划" } },
        { path: 'train-plan-pass', meta: { title: "计划审核" } },
        { path: 'train-application', meta: { title: "报名管理" } },
        { path: 'train-train', meta: { title: "培训管理" } },
        { path: 'red-envelopes', meta: { title: "红包管理" } },
      ]
    },

    // 人事报表{ path: 'personnelReport', meta: { title: "人事报表" } },
    {
      path: 'personnelReport',
      component: Wujie,
      props: { type: 'hr' },
      children: [
        { path: 'index', meta: { title: "人事报表" } },
      ]
    },

    // 企业微信
    {
      path: 'user-group',
      component: Wujie,
      props: { type: 'quality' },
      children: [
        { path: 'list', meta: { title: "内部群管理" } },
        { path: 'send', meta: { title: "消息推送" } },
        { path: 'log', meta: { title: "消息管理" } },
      ]
    },

    // 维保系统
    {
      path: 'maintenance',
      component: Wujie,
      props: { type: 'school' },
      children: [
        { path: 'index', meta: { title: "维保统计" } },

        // 维保排期
        { path: 'plan', meta: { title: "保养计划" } },
        { path: 'schedule', meta: { title: "保养排期" } },
        { path: 'elevator-list', meta: { title: "电梯管理" } },
        { path: 'customer-list', meta: { title: "使用单位" } },
        { path: 'project-list', meta: { title: "项目管理" } },
        { path: 'elevator-check', meta: { title: "电梯信息审核" } },

        // 维保工单
        { path: 'work-order', meta: { title: "保养单" } },
        { path: 'urgent-order', meta: { title: "维修单" } },
        { path: 'repair-order', meta: { title: "大修单" } },
        { path: 'rescue-order', meta: { title: "救援单" } },
        { path: 'order-check', meta: { title: "工单审核" } },
        { path: 'work-comment', meta: { title: "评分表" } },

        // 维保人员
        { path: 'user-group', meta: { title: "班组管理" } },
        { path: 'user-certificate', meta: { title: "证件管理" } },

        // 维保设置
        { path: 'config', meta: { title: "维保参数" } },
        { path: 'template', meta: { title: "维保项" } },

        // 销售合同
        // { path: 'contract-manage', meta: { title: "合同管理" } },
        // { path: 'contract-review', meta: { title: "合同审核" } },
        // { path: 'contract-params', meta: { title: "销售参数" } },
        // 财务
        { path: 'finance', meta: { title: "汇总报表" } },
        { path: 'payment', meta: { title: "应收应付管理" } },
        { path: 'payment-log', meta: { title: "收付记录" } },
      ]
    },
    // 消防维保
    {
      path: 'fireproof',
      component: Wujie,
      props: { type: 'school' },
      children: [
        { path: 'index', meta: { title: "维保统计" } },
        // 维保排期
        { path: 'schedule', meta: { title: "维保计划" } },
        { path: 'schedule-detail', meta: { title: "计划明细" } },
        { path: 'plan-detail', meta: { title: "计划详情" } },
        { path: 'report', meta: { title: "线下报告" } },
        { path: 'project', meta: { title: "项目管理" } },
        // { path: 'customer', meta: { title: "使用单位" } },
        // { path: 'project', meta: { title: "项目管理" } },
        // { path: 'elevator-check', meta: { title: "器材信息审核" } },
        // 维保工单
        // { path: 'work-order', meta: { title: "保养单" } },
        // { path: 'urgent-order', meta: { title: "急修单" } },
        // { path: 'repair-order', meta: { title: "大修单" } },
        // { path: 'rescue-order', meta: { title: "救援单" } },
        // { path: 'order-check', meta: { title: "工单审核" } },
        // 维保人员
        { path: 'worker', meta: { title: "班组管理" } },
        // { path: 'user-certificate', meta: { title: "证件管理" } },
        // 维保设置
        { path: 'template', meta: { title: "维保项" } },
        // 合同管理
        { path: 'contract-manage', meta: { title: "合同管理" } },
      ]
    },
    // 智能维保
    {
      path: 'intellect',
      component: Wujie,
      props: { type: 'school' },
      children: [
        { path: 'index', meta: { title: "维保统计" } },
        // 维保排期
        { path: 'plan', meta: { title: "保养计划" } },
        { path: 'schedule', meta: { title: "保养排期" } },
        { path: 'equipment', meta: { title: "产品管理" } },
        { path: 'customer', meta: { title: "使用单位" } },
        { path: 'project', meta: { title: "项目管理" } },
        { path: 'elevator-check', meta: { title: "产品信息审核" } },
        // 维保工单
        { path: 'work-order', meta: { title: "保养单" } },
        { path: 'urgent-order', meta: { title: "急修单" } },
        { path: 'repair-order', meta: { title: "大修单" } },
        { path: 'rescue-order', meta: { title: "救援单" } },
        { path: 'order-check', meta: { title: "工单审核" } },
        // 维保人员
        { path: 'user-group', meta: { title: "班组管理" } },
        { path: 'user-certificate', meta: { title: "证件管理" } },
        // 维保设置
        { path: 'config', meta: { title: "维保参数" } },
        { path: 'template', meta: { title: "维保项" } },
        // 销售合同
        { path: 'contract-manage', meta: { title: "合同管理" } },
      ]
    },
    // 甲方管理
    {
      path: 'score',
      component: Wujie,
      props: { type: 'school' },
      children: [
        { path: 'user', meta: { title: "人员管理" } },
        { path: 'user-role', meta: { title: "角色管理" } },
        { path: 'user-report', meta: { title: "用户使用情况" } },
        { path: 'work-order', meta: { title: "工单管理" } },
        { path: 'comment', meta: { title: "评分表管理" } },
        { path: 'comment-template', meta: { title: "评分模板管理" } },
        // { path: 'comment-item', meta: { title: "评分项管理" } },
        { path: 'comment-template', meta: { title: "评分模板管理" } },
        { path: 'survey-list', meta: { title: "满意度调查" } },
        { path: 'survey-template', meta: { title: "满意度模板" } },
      ]
    },
    // 智慧停车
    {
      path: 'park',
      component: Wujie,
      props: { type: 'school' },
      children: [
        { path: 'index', meta: { title: "停车场列表" } },
        { path: 'income', meta: { title: "支付汇总表" } },
      ]
    },
    // 维保系统
    {
      path: 'weak-current',
      component: Wujie,
      props: { type: 'school' },
      children: [
        { path: 'urgent-order', meta: { title: "弱电维修单" } },
      ]
    },

    // 项目定位
    {
      path: 'project-location',
      component: Wujie,
      props: { type: 'office' },
      children: [
        { path: 'list', meta: { title: "项目列表" } },
        { path: 'config', meta: { title: "参数设置" } },
        { path: 'permission', meta: { title: "权限管理" } },
      ]
    },
 // 总裁看板,
    {
      path: 'cockpit',
      component: Wujie,
      props: { type: 'cockpit' },
      children: [
        { path: 'desktop', meta: { title: "总裁看板" } },
      ]
    },
    // 盖章管理
    {
      path: 'stamp',
      component: Wujie,
      props: { type: 'tools' },
      children: [
        { path: 'mark', meta: { title: "印章管理" } },
        { path: 'file', meta: { title: "文件盖章" } },
        { path: 'log', meta: { title: "盖章记录" } },
      ]
    },

    // 报事报修
    {
      path: 'workorder',
      component: Wujie,
      props: { type: 'quality' },
      children: [
        { path: 'order', meta: { title: "工单列表" } },
        { path: 'permission', meta: { title: "权限管理" } },
      ]
    },

    // 预算编辑
    {
      path: 'center',
      component: Wujie,
      props: { type: 'budget' },
      children : [
        { path : 'index1' , meta : {title : '项目预算模板'}},
        { path : 'index2' , meta : {title : '职能预算模板'}},
        { path : 'index3' , meta : {title : '市场预算模板'}},
        { path : 'report1' , meta : {title : '项目预算汇总'}},
        { path : 'report2' , meta : {title : '职能预算汇总'}},
        { path : 'report3' , meta : {title : '市场预算汇总'}},
        { path : 'report-multi' , meta : {title : '分项目汇总'}},
        { path : 'permission' , meta : {title : '权限管理'}},
        { path : 'base' , meta : {title : '基础数据导入'}},
      ]
    },
    {
      path: 'zyx',
      component: Wujie,
      props: { type: 'zyx' },
      children: [
        {path: 'user', meta: {title: '用户列表'}},
        {path: 'user/invoice', meta: {title: '用户发票'}},
        {path: 'repair', meta: {title: '报修管理'}},
        {path: 'order/list', meta: {title: '订单列表'}},
        {path: 'order/refund', meta: {title: '退款列表'}},
        {path: 'frontend/config/list', meta: {title: '页面配置'}},
        {path: 'frontend/config/group', meta: {title: '页面配置分组'}},
        {path: 'contact/info/list', meta: {title: '管家联系方式'}},
        {path: 'contact/info/category', meta: {title: '联系方式分类'}},
        {path: 'company', meta: {title: '分公司信息'}}
      ]
    }

  ]
}



// WEBPACK FOOTER //
// ./src/router/wujie.js